module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAACXBIWXMAAAsSAAALEgHS3X78AAAA6UlEQVQoz92TIW7DUAyGv7QFg4VhzQ0a8A6QnWA9QqBh6FhZ4cae4Y7QSgGDGbe03KApK+wN3ogrdVunTVXQfsnElj7/v2RnKSXG0ISRNBpomud5ZWbrEML2FoCqbs3sOAFOwEpVmxsga6AChmnbtkczuwM2ZnYIIfR/hNTAE/AoIq9ZjHEOdMAcWAA7oBGR4QdAATwDD8DBE1UzoHZICRTAC7BX1R3Q+xI8QnkBuPd5D9RZSglVLc4OVLUE3t1ZASwd9OagTkRWlw5FZCCl9KlijE2Mcfja/2127Y5OHu+aOo/yTdn/fZEPPVaE3hTr6mEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/sso/components/login/images/open.png
// module id = 435
// module chunks = 0